import React from 'react'

const InstantLoanEmiReport = () => {
  return (
    <div>
      
    </div>
  )
}

export default InstantLoanEmiReport
